import type { UseStorageOptions } from './useStorage';
import { getStorage, useStorage } from './useStorage';

export function getLocalStorage<T>(key: string, initialValue: T, options?: UseStorageOptions) {
  return getStorage(window.localStorage, key, initialValue, options);
}

export function useLocalStorage<T>(key: string, initialValue: T, options?: UseStorageOptions) {
  return useStorage(window.localStorage, key, initialValue, options);
}
